import {omneticApi} from '@dms/api/base';

import {GetCheckoutMessageLogApiArg, GetCheckoutMessageLogApiResponse} from './types';

export const integrationApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getCheckoutMessageLog: build.query<
      GetCheckoutMessageLogApiResponse,
      GetCheckoutMessageLogApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/integration/checkout-message-log/${queryArg.checkoutId}`,
      }),
    }),
  }),
});

export const {useGetCheckoutMessageLogQuery} = integrationApi;
